import React, { useState, useEffect } from "react";
import { Table, Row } from "react-bootstrap";
import { FormControl, Select, InputLabel, MenuItem } from "@material-ui/core";
import BasicPagination from "../../../Pagination/Pagination";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import { SuperAdminTopTextSearchIcon } from "./Filters";
import moment from "moment";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import { adminScanPay } from "../../../../store/actions/SuperAdminActions/superAdminManageTransactions";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import { connect } from "react-redux";
import SelectFilter from "../../../reusableComponents/selectFilter";
import isEmpty from "../../../../store/validation/is-Empty";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";
import { SortComponent } from "../../../reusableComponents/SortAndFilterComponent/SortComponent";
import {
  USER_WALLET_TRANSACTION_TYPE,
  PAYMENT_STATUS_TYPE,
} from "../../../../enums/SuperadminWalletEnum";
import ViewTransactionModal from "../superAdminUserWallatTransactions/ViewTransactionModal";
import NoContent from "../../../reusableComponents/NoContentComponent";

const orderType = [
  { id: 0, title: "Takeaway" },
  { id: 1, title: "Curb-side" },
  { id: 2, title: "Skip-The Line" },
  { id: 3, title: "Dine-In" },
  { id: 10, title: "All" },
];

const SuperAdminScanPay = (props) => {
  //state
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [page, setPage] = useState(1);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    let calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
    //page = pageNo;
  };

  const [paymentType, setPaymentType] = useState("All");
  const [paymentStatus, setPaymentStatus] = useState("All");
  // const [selectDate, setSelectDate] = useState("");
  const [filter, showFilter] = useState(false);
  const [stateOne, setStateOne] = useState({
    search: "",
    anchorEl: null,
    restaurantReverse: "",
    showFilter: false,
    paymentTypeText: "All",
    paymentStatusText: "All",
  });

  /*********************************
   * @DESC Search Bar Action
   *********************************/
  const onSearchChange = (e) => {
    setStateOne({
      ...stateOne,
      search: e.target.value,
    });
  };
  const onFilterSave = (e) => {
    setStateOne({
      ...stateOne,
      paymentTypeText: paymentType,
      paymentStatusText: paymentStatus,
    });
    showFilter(!filter);
  };

  const onChangepaymentType = (e) => {
    setPaymentType(e.target.value);
  };
  const onChangePaymentStatus = (e) => {
    setPaymentStatus(e.target.value);
  };

  /*********************************
   * @DESC SORT FILTER ACTION
   *********************************/
  const handleClick = (event) => {
    setStateOne({
      ...stateOne,
      anchorEl: event.currentTarget,
    });
  };

  const handleCloseOne = () => {
    setStateOne({
      ...stateOne,
      anchorEl: null,
    });
  };

  const handleSelect = (value) => () => {
    setStateOne({
      ...stateOne,
      restaurantReverse: value,
      anchorEl: false,
    });
  };

  const [dateQuery, setDateQuery] = useState({});

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
  };

  /*****************************************
   * @DESC Download Button Action
   ****************************************/
  // const downloadData = {
  //   headers: [
  //     { label: "Transaction Id", key: "transactionId" },
  //     { label: "Department Code", key: "departmentcode" },
  //     { label: "Reason", key: "reason" },
  //     { label: "Comments", key: "comments" },
  //     { label: "Request Date & Time", key: "requestDateTime" },
  //     { label: "Amount", key: "amount" },
  //     { label: "Status", key: "status" },
  //   ],
  //   data:
  //     props?.scan_pay &&
  //     props?.scan_pay.map((ele) => {
  //       return {
  //         transactionId: ele?._id,
  //         departmentcode: ele?.departmentalCode,
  //         reason: ele?.reason,
  //         comments: ele?.message,
  //         requestDateTime: `${moment(ele?.createdAt).format("ll")}`,
  //         amount: ele?.amount,
  //         status: ele?.status,
  //       };
  //     }),
  // };

  let filteredData = [];
  if (
    stateOne.restaurantReverse === "" &&
    stateOne.paymentTypeText === "All" &&
    stateOne.paymentStatusText === "All"
  ) {
    filteredData = props.scan_pay;
  }
  if (stateOne.paymentTypeText === "SCAN AND PAY") {
    filteredData = props.scan_pay.filter(
      (data) => data.transaction_type === "SCAN_AND_PAY"
    );
  }
  if (stateOne.paymentTypeText === "WALLET") {
    filteredData = props.scan_pay.filter(
      (data) => data.transaction_type === "WALLET"
    );
  }
  if (stateOne.paymentStatusText === "Success") {
    filteredData = props.scan_pay.filter(
      (data) => data.payment_captured === true
    );
  }
  if (stateOne.paymentStatusText === "Pending") {
    filteredData = props.scan_pay.filter(
      (data) => data.payment_captured === false
    );
  }
  if (stateOne.restaurantReverse === "A-Z") {
    filteredData = props?.scan_pay.sort((a, b) => {
      if (
        a?.user_id?.first_name + " " + a?.user_id?.last_name <
        b?.user_id?.first_name + " " + b?.user_id?.last_name
      )
        return -1;
      if (
        a?.user_id?.first_name + " " + a?.user_id?.last_name >
        b?.user_id?.first_name + " " + b?.user_id?.last_name
      )
        return 1;
      return 0;
    });
  } else if (stateOne.restaurantReverse === "Z-A") {
    filteredData = props?.scan_pay.sort((a, b) => {
      if (
        a?.user_id?.first_name + " " + a?.user_id?.last_name <
        b?.user_id?.first_name + " " + b?.user_id?.last_name
      )
        return 1;
      if (
        a?.user_id?.first_name + " " + a?.user_id?.last_name >
        b?.user_id?.first_name + " " + b?.user_id?.last_name
      )
        return -1;
      return 0;
    });
  }
  if (stateOne.search) {
    let search = new RegExp(stateOne.search, "i");
    filteredData = props.scan_pay.filter((getall) => {
      if (search.test(getall?.restaurant_id?.restaurant_name)) {
        return getall;
      } else if (search.test(getall?.restaurant_id?.city)) {
        return getall;
      } else if (
        search.test(
          getall?.user_id?.first_name + " " + getall?.user_id?.last_name
        )
      ) {
        return getall;
      } else {
        return false;
      }
    });
  }

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      const token = props.auth.user.accessToken;
      let query = {
        transaction_type: "SCAN_AND_PAY",
        startDate: dateQuery.startDate,
        endDate: dateQuery.endDate,
      };
      props.adminScanPay(token, query);
    }
  }, [dateQuery]);

  useEffect(() => {
    setPage(1);
    setStart(0);
    setEnd(10);
  }, [stateOne.search]);

  const downloadData = {
    headers: [
      { label: "Request Type/Request ID", key: "id" },
      { label: "Business", key: "restaurant_name" },
      { label: "Business Id", key: "b_id" },
      { label: "City", key: "city" },
      { label: "User Name", key: "user_name" },
      { label: "Total  Amount", key: "amount" },
      { label: "Payment Gateway", key: "payment_gateway" },
      { label: " Payment Status", key: "payment_status" },
      { label: " Payment Type /Transaction ID", key: "payment_type" },
    ],
    data: filteredData
      ? filteredData?.map((ele) => {
        return {
          id: ele?.orderId?._id,
          restaurant_name: ele?.restaurant_id?.restaurant_name,
          b_id: ele?.restaurant_id?._id,
          city: ele?.restaurant_id?.city,
          user_name: ele?.user_id?.first_name + " " + ele?.user_id?.last_name,
          amount: ele?.amount,
          payment_gateway: "Razor Pay",
          payment_status: ele?.payment_captured ? "Success" : "Pending",
          payment_type:
            ele?.transaction_type === "SCAN_AND_PAY" &&
            "Scan & Pay " + " " + ele?._id,
        };
      })
      : [],
  };

  return (
    <React.Fragment>
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation />
              <div className="super-admin-inside-right-side-panel">
                <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                  <div className="f24_700_HelveticaNeue">Scan & Pay</div>
                </div>
                <div className="row flexcenter">
                  <div className="col-4">
                    <Form.Control
                      type="text"
                      placeholder="Search"
                      name="search"
                      onChange={onSearchChange}
                      value={stateOne.search}
                      className="amSearch"
                    />
                  </div>
                  <div className="col-3"></div>
                  <div className="col-3">
                    <div className="mr-3">
                      <SelectFilter defaultSelected={"TODAY"} onDateChange={onDateChangeHandler()} />
                    </div>
                  </div>
                  <div className="col-2">
                    <div className="d-flex align-items-center">
                      <SortComponent
                        handleClick={handleClick}
                        anchorEl={stateOne.anchorEl}
                        handleClose={handleCloseOne}
                        selectClick={(data) => handleSelect(data)}
                      />
                      <div
                        className="f10-400"
                        align="center"
                        onClick={() => showFilter(!filter)}
                      >
                        <img
                          src={require("../../../../assets/images/iconButton/filterbtn.svg")}
                          width="80px"
                        />
                      </div>
                      <div className="f10-400" align="center">
                        <CSVDownloader
                          filename={"Scan & Pay"}
                          headers={downloadData.headers}
                          data={downloadData.data}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  {filter && (
                    <div className="mt-3 mb-3">
                      <Row>
                        <div className="col-3">
                          <div className="mr-3">
                            <FormControl variant="outlined" fullWidth>
                              <InputLabel id="demo-simple-select-outlined-label">
                                Payment Type
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                name="paymentType"
                                value={paymentType}
                                onChange={(e) => onChangepaymentType(e)}
                                label="Payment Type"
                              >
                                {USER_WALLET_TRANSACTION_TYPE.map(
                                  (item, index) => (
                                    <MenuItem key={index} value={item}>
                                      {item}
                                    </MenuItem>
                                  )
                                )}
                              </Select>
                            </FormControl>
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="mr-3">
                            <FormControl variant="outlined" fullWidth>
                              <InputLabel id="demo-simple-select-outlined-label">
                                Payment Status
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                name="paymentStatus"
                                value={paymentStatus}
                                onChange={(e) => onChangePaymentStatus(e)}
                                label="Payment Status"
                              >
                                {PAYMENT_STATUS_TYPE.map((item, index) => (
                                  <MenuItem key={index} value={item}>
                                    {item}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                        </div>
                      </Row>
                      <div class="d-flex align-items-center mt-4">
                        <button
                          type="button"
                          className="btn-md mr-4 px-5 btn btn-outline-secondary"
                          onClick={() => showFilter(!filter)}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn-md px-5 btn btn-danger"
                          onClick={onFilterSave}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                  <Table className="HideShowTable enMinWidth900">
                    <thead>
                      <tr className="super_admin_all_users_table_head">
                        {/* <th style={{ width: "15%" }} className="f12-700">
                          Request Type/ <br />
                          Request ID
                        </th> */}
                        <th style={{ width: "20%" }} className="f12-700">
                          Business
                        </th>
                        <th style={{ width: "20%" }} className="f12-700">
                          User
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Total
                          <br />
                          Amount
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Payment <br />
                          Gateway
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Payment <br />
                          Status
                        </th>
                        <th style={{ width: "15%" }} className="f12-700">
                          Payment Type/ <br />
                          Transaction ID
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Action
                        </th>
                        {/* <th style={{ width: "9%" }} className="f12-700">
                            Status
                          </th>
                          <th style={{ width: "10%" }} className="f12-700">
                            Settlement
                            <br />
                            Response Text
                          </th>
                          <th style={{ width: "9%" }} className="f12-700">
                            Refund
                            <br />
                            ID
                          </th>
                          <th style={{ width: "9%" }} className="f12-700">
                            Merchant
                            <br />
                            Account ID
                          </th> */}
                      </tr>
                    </thead>
                    {props.auth.loader ? (
                      <AmealioLoader />
                    ) : (
                      <>
                        {filteredData?.length ? filteredData
                          .slice(start, end)
                          .map((transaction, index) => (
                            <tbody key={index}>
                              <tr className="super_admin_all_users_table_body  super-admin-suggestion-table-body  text-break">
                                {/* <td style={{ width: "15%" }}>
                                  <div className="f12-400">
                                    {transaction?.orderId && (
                                      <>
                                        <div>
                                          {orderType.map((data) => (
                                            <span>
                                              {data.id ===
                                                transaction?.orderId
                                                  ?.order_type && data.title}
                                            </span>
                                          ))}
                                        </div>
                                        <br />
                                        {transaction?.orderId?._id}
                                      </>
                                    )}

                                    {transaction?.event_request_id?.event_type}
                                    <br />
                                    {transaction?.event_request_id?._id}
                                  </div>
                                </td> */}
                                <td style={{ width: "20%" }}>
                                  {transaction.restaurant_id && (
                                    <div class="super-admin-suggestion-table-body-boxone">
                                      <div class="super-admin-suggestion-imageBox mr-3">
                                        <div>
                                          <img
                                            src={
                                              transaction?.restaurant_id
                                                ?.logo_url
                                            }
                                            style={{ minWidth: "40px" }}
                                            alt="Icon"
                                            title="Restaurant Picture"
                                            class="img-fluid"
                                            srl_elementid="0"
                                          />
                                        </div>
                                      </div>
                                      <div class="super-admin-suggestion-imageBoxText pl-0">
                                        <div class="f14-500">
                                          {
                                            transaction?.restaurant_id
                                              ?.restaurant_name
                                          }
                                        </div>
                                        <div class="f12-400">
                                          {transaction?.restaurant_id?._id}
                                        </div>
                                        <div class="f10-400">
                                          {transaction?.restaurant_id?.city}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </td>
                                <td style={{ width: "20%" }}>
                                  {transaction.user_id && (
                                    <div class="super-admin-suggestion-table-body-boxone">
                                      <div class="super-admin-suggestion-imageBoxText pl-0">
                                        <div class="f14-500">
                                          {transaction?.user_id?.first_name}{" "}
                                          {transaction?.user_id?.last_name}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </td>
                                <td style={{ width: "10%" }}>
                                  <div className="f12-400 text-break">
                                    ₹{" "}
                                    {parseFloat(transaction.amount).toFixed(2)}
                                  </div>
                                </td>
                                <td style={{ width: "10%" }}>
                                  <div className="f12-400">Razor Pay</div>
                                </td>
                                <td style={{ width: "10%" }}>
                                  <div
                                    className={`${transaction.payment_captured
                                        ? "enSuccessLBL"
                                        : "enPendingLBL"
                                      }`}
                                  >
                                    {transaction.payment_captured
                                      ? "Success"
                                      : "Failed"}
                                  </div>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <td style={{ width: "15%" }}>
                                    <p className="f14-500">
                                      {transaction.transaction_type ===
                                        "SCAN_AND_PAY" && "Scan & Pay"}
                                    </p>
                                    <p className="f12-400">
                                      {transaction?.transactionNumber !==
                                        undefined &&
                                        transaction?.transactionNumber !== null &&
                                        transaction?.transactionNumber !== ""
                                        ? transaction?.transactionNumber
                                        : "N/A"}
                                    </p>
                                  </td>
                                </td>
                                <td style={{ width: "10%" }}>
                                  <ViewTransactionModal data={transaction} />
                                </td>
                                {/* <td style={{ width: "10%" }}>
                                <div className="f12-400 text-break">XXXXXX</div>
                              </td>
                              <td style={{ width: "9%" }}>
                                <div className="f12-400 text-break">XXXXXX</div>
                              </td>
                              <td style={{ width: "9%" }}>
                                <div className="f12-400 text-break">XXXXXX</div>
                              </td> */}
                              </tr>
                            </tbody>
                          )) : <NoContent />}
                      </>
                    )}
                  </Table>
                </div>
                {filteredData?.length > 1 ? (
                  <BasicPagination
                    totalRecords={filteredData.length}
                    limit={10}
                    batch={page}
                    onBatchChange={(e) => handleBatchChange(e)}
                  />
                ) : (
                  <> </>
                )}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    </React.Fragment>
  );
};
SuperAdminScanPay.propTypes = {
  auth: PropTypes.object.isRequired,
  adminScanPay: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  scan_pay: state.superadminManageTransactions.scan_pay,
});

export default connect(mapStateToProps, {
  adminScanPay,
})(SuperAdminScanPay);
